import { useEffect } from 'react';
import { autoInitLang } from '../i18n/langDetect';

/**
 * Runs autoInitLang() once at mount. First visit: picks HU/PL/DE if the
 * browser or IP suggests it, then stores the choice so the whole tree
 * (marketing site + app) speaks the same language on every subsequent
 * visit until the user manually switches.
 */
export default function LangBootstrap() {
  useEffect(() => {
    let cancelled = false;
    (async () => {
      const before = localStorage.getItem('keystone_app_lang');
      const picked = await autoInitLang();
      if (cancelled) return;
      // If auto-detect just chose a non-EN language on a first visit (no
      // saved choice yet), reload so the marketing bundles + DomTranslator
      // pick it up cleanly. Subsequent visits already have `before` set.
      if (!before && picked && picked !== 'en') window.location.reload();
    })();
    return () => { cancelled = true; };
  }, []);
  return null;
}
